import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as NotificationActions from './notification.actions';
import { INotification } from '@qld-recreational/models';
import { without } from '@qld-recreational/ramda';
import * as dayjs from 'dayjs';
import { utcNow } from '@qld-recreational/moment';
import { clearSessionData } from '../settings/settings.actions';
import { switchUser } from '../auth/auth.actions';

export const notificationsFeatureKey = 'notifications';

export interface INotificationState extends EntityState<INotification> {
  userId: string;
  readNotificationIds: string[];
  lastLoadedDateTime?: string;
}

export const adapter: EntityAdapter<INotification> =
  createEntityAdapter<INotification>({
    selectId: (notification) => notification.id,
    sortComparer: (notificationA, notificationB) =>
      dayjs(notificationA.dateTime).isBefore(dayjs(notificationB.dateTime))
        ? 1
        : -1,
  });

export const initialState = (): INotificationState =>
  adapter.getInitialState({
    userId: undefined,
    readNotificationIds: [],
    lastLoadedDateTime: utcNow(),
  });

export const reducer = createReducer(
  initialState(),
  on(NotificationActions.deleteNotification, (state, action) =>
    adapter.removeOne(action.id, {
      ...state,
      readNotificationIds: without([action.id], state.readNotificationIds),
    }),
  ),
  on(
    NotificationActions.setReadNotificationIds,
    (state, { readNotificationIds }) => ({
      ...state,
      readNotificationIds,
    }),
  ),
  on(NotificationActions.addReadNotificationId, (state, { id }) => ({
    ...state,
    readNotificationIds: [...state.readNotificationIds, id],
  })),
  on(
    NotificationActions.loadNewNotificationsSuccess,
    (state, { notifications }) =>
      adapter.addMany(notifications, {
        ...state,
        lastLoadedDateTime: utcNow(),
      }),
  ),
  on(clearSessionData, switchUser, () => initialState()),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();
